import { SimpleText } from "components/common/text/SimpleText";
import useDateFns from "components/hooks/useDateFns";
import React from "react";
import FallbackText from "./FallbackText";

export default ({
  value,
  fallbackValue,
}: {
  value?: string;
  fallbackValue?: string;
}) => {
  const { formatTimeString } = useDateFns();

  return value ? (
    <SimpleText>{formatTimeString(value)}</SimpleText>
  ) : (
    <FallbackText>
      {fallbackValue ? formatTimeString(fallbackValue) : ""}
    </FallbackText>
  );
};
